module.exports = __webpack_public_path__ + "static/img/home_p7.53b9cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/home_p7.jpg
// module id = 490
// module chunks = 2 3 8